// Change the date from "x hours/days ago" to "Month DD, YYYY" format
var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function changeDate() {
    var reviewElements = document.querySelectorAll('[data-oke-reviews-date]');

    reviewElements.forEach(function (review) {
        var d = review.getAttribute('data-oke-reviews-date');
        var date = new Date(d);
        review.innerHTML = MONTHS[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
    })
}

window.okeReviewsWidgetOnInit = function () {
    changeDate();
    var observer = new MutationObserver(function (records) {
        changeDate();
    });
    var reviewMainElement = document.querySelector('.js-okeReviews-reviews-main');
    observer.observe(reviewMainElement, {
        childList: true
    });
}

//Question element date change
var checkLoop = setInterval(function () {
    var questionMainElement = document.querySelector('.js-okeReviews-questions-main');
    if (questionMainElement) {
        changeDate();
        var observer = new MutationObserver(function (records) {
            setupWidget();
            changeDate();
        });
        observer.observe(questionMainElement, {
            childList: true
        });
        clearInterval(checkLoop);
    }
}, 100);